import { render, staticRenderFns } from "./v_member.vue?vue&type=template&id=2c13fdfd&"
import script from "./v_member.vue?vue&type=script&lang=js&"
export * from "./v_member.vue?vue&type=script&lang=js&"
import style0 from "./v_member.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports